import Marquee from "react-fast-marquee";
import { Hand, Leaf, Sparkles } from "lucide-react";
import { IMAGES } from "@/data/salon";
import { Overline, Reveal } from "@/components/Reveal";

const FEATURES = [
    {
        icon: Sparkles,
        title: "Consulenza gratuita",
        text: "Prima di ogni servizio, un confronto onesto su ciò che valorizza davvero i tuoi capelli. Anche solo da una foto.",
    },
    {
        icon: Hand,
        title: "Massaggio al cuoio capelluto",
        text: "Il nostro rituale: durante lo shampoo, un massaggio rilassante che altrove quasi nessuno fa. Le clienti lo adorano.",
    },
    {
        icon: Leaf,
        title: "Prodotti professionali",
        text: "Solo linee professionali selezionate, scelte per rispettare la fibra del capello e mantenere il risultato nel tempo.",
    },
];

const Experience = () => (
    <section id="esperienza" data-testid="experience-section" className="bg-cream">
        <div className="border-y border-linen py-6 md:py-8 overflow-hidden" data-testid="editorial-marquee">
            <Marquee speed={35} gradient={false} pauseOnHover>
                {["L'esperienza in salone", "Moovie Parrucchieri", "Consulenza personalizzata", "Cura & ascolto"].map(
                    (t) => (
                        <span
                            key={t}
                            className="font-serif uppercase whitespace-nowrap leading-none text-[9vw] md:text-[5.5vw] text-ink/90 mx-6 md:mx-10"
                        >
                            {t} <em className="italic text-rosegold not-italic-none">·</em>
                        </span>
                    ),
                )}
            </Marquee>
        </div>

        <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-24 md:py-32">
            <Reveal className="max-w-2xl">
                <Overline>L'Esperienza in Salone</Overline>
                <h2 className="font-serif text-4xl md:text-6xl leading-[1.02] tracking-tight text-ink mt-4">
                    I dettagli che fanno la{" "}
                    <em className="italic text-sage">differenza</em>
                </h2>
            </Reveal>

            <div className="mt-14 grid lg:grid-cols-[1.1fr_1fr] gap-14 lg:gap-20 items-center">
                <Reveal delay={0.1}>
                    <div className="relative">
                        <div className="overflow-hidden border border-linen/70">
                            <img
                                src={IMAGES.wash}
                                alt="Rituale di shampoo con massaggio al cuoio capelluto"
                                className="w-full aspect-[4/3] object-cover hover:scale-[1.03] transition-transform duration-700"
                            />
                        </div>
                        <p className="mt-3 text-xs tracking-[0.2em] uppercase text-stone2/70">
                            Il rituale dello shampoo · massaggio incluso
                        </p>
                    </div>
                </Reveal>

                <div className="flex flex-col gap-2">
                    {FEATURES.map((f, i) => (
                        <Reveal key={f.title} delay={i * 0.12}>
                            <div
                                data-testid={`experience-feature-${i + 1}`}
                                className="group flex gap-5 border-t border-linen py-7 first:border-t-0"
                            >
                                <div className="shrink-0 w-12 h-12 rounded-full border border-linen flex items-center justify-center text-sage group-hover:bg-sage group-hover:text-cream group-hover:border-sage transition-colors duration-300">
                                    <f.icon size={20} strokeWidth={1.6} />
                                </div>
                                <div>
                                    <h3 className="font-serif text-xl md:text-2xl text-ink">
                                        {f.title}
                                    </h3>
                                    <p className="mt-2 text-sm md:text-base text-stone2 leading-relaxed">
                                        {f.text}
                                    </p>
                                </div>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </div>
    </section>
);

export default Experience;
